<div class="pinInputWrapper">
  <div class="ic1-flex">
    <ng-container *ngIf="refreshOtp">
      <ng-ui-kit-otp
        #ngUiKitOtp
        [icId]="'confirm-pin-input-' + (formControlName || 'confirmPin')"
        [type]="'number'"
        [title]="resolvedLabel"
        [resendBtn]="resendBtnConfig"
        [length]="pinLength"
        [disabled]="disabled"
        [error]="error"
        [hideValue]="hideValue"
        (onChange)="onChange($event)"
        (keydown.enter)="onEnter($event)">
      </ng-ui-kit-otp>
    </ng-container>
  </div>
</div>
